import { Divider, Typography } from '@mui/material';
import clsx from 'clsx';
import { format } from 'date-fns';
import { ReactNode } from 'react';

import styles from './TimelineEventCard.module.scss';


interface TimelineEventCardProps {
    children?: ReactNode;
    className?: string;
    header: ReactNode;
    actions: ReactNode;
    secondaryText: ReactNode;
    date: Date;
}

export function TimelineEventCard({
    actions, children, date, header, secondaryText, className
}: TimelineEventCardProps) {
    return (
        <div className={clsx(styles.root, className)}>
            <div className={styles.card}>
                <div className={styles.row}>
                    <Typography fontWeight={500}>
                        {header}
                    </Typography>

                    <div className={styles.buttonContainer}>
                        {actions}
                    </div>
                </div>

                <div className={styles.row}>
                    <Typography
                        variant="caption"
                        color="textSecondary"
                    >
                        {secondaryText}
                    </Typography>

                    <Typography
                        variant="caption"
                        color="textSecondary"
                    >
                        {format(date, 'h:mm aaa')}
                    </Typography>
                </div>

                {children}
            </div>

            <Divider className={styles.divider} />
        </div>
    );
}
